import React from 'react'
import cx from 'classnames'

import { useAppSelector } from 'reduxTyped'
import { AiAutomationLayoutSelectors } from 'apps/aiAutomation/store/layout'

import cm from './styles.module.css'

interface ContentProps {
  children: React.ReactNode
  className?: string
  isWide?: boolean
}

export const Content = ({ children, className, isWide = false }: ContentProps) => {
  const isSidebarOpen = useAppSelector(AiAutomationLayoutSelectors.getIsSidebarOpen)

  return (
    <div className={cm.layoutContentWrapper}>
      <main
        className={cx(cm.layoutContent, className, {
          [cm.layoutContent_muted]: isSidebarOpen,
          [cm.layoutContent_wide]: isWide,
        })}
        // @ts-expect-error type for inert is supported starting from React 19+
        // It's also not working for now when we pass true/false, that's why there is an empty string and undefined values
        inert={isSidebarOpen ? '' : undefined}
      >
        {children}
      </main>
    </div>
  )
}
